import { render, staticRenderFns } from "./VendorBagList.vue?vue&type=template&id=11a5c743&scoped=true&"
import script from "./VendorBagList.vue?vue&type=script&lang=js&"
export * from "./VendorBagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a5c743",
  null
  
)

export default component.exports